//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lensTechnologies from '~/constants/lensTechnologies'

export default {
  props: {
    sku: { type: String, required: true }
  },
  computed: {
    lensTech () {
      return this.$store.getters['product/lensTech'](this.sku)
    },
    lensTechDetails () {
      return lensTechnologies.find(row => row.tech === this.lensTech) || {}
    }
  }
}
